// Labels for the tools the Companion agent can invoke. Keys can be a
// bare `tool` (e.g. `notes`) for the generic case, or `tool.action`
// (e.g. `notes.create`) for a more specific phrasing — the custom-tool
// dispatch on the BE keys behaviour off `tool_input.action`, see the
// *_ACTIONS maps in `scribenote-agent/tools/`. Action-specific labels
// take precedence; the bare `tool` key is the fallback for built-in
// (Anthropic) tools that have no action and as a safety net if the BE
// adds a new action before the FE picks it up.
export const TOOL_LABEL: Record<string, string> = {
  // Built-in (Anthropic) tools
  bash: "Crunching the numbers",
  web_search: "Searching the web",
  web_fetch: "Fetching a page",

  // Custom tools — generic fallback per tool
  notes: "Looking through your notes",
  patients: "Looking up a patient",
  templates: "Browsing your templates",
  memory: "Checking memory",
  navigation: "Finding the right page",
  support: "Searching the help docs",
  support_escalation: "Reaching out to support",
  user_context: "Checking your account",
  treats: "Checking your treat balance",

  // notes.*
  "notes.list": "Looking through your notes",
  "notes.search": "Searching your notes",
  "notes.get": "Reading a note",
  "notes.create": "Drafting a note",
  "notes.update_status": "Updating note status",
  "notes.propose_edit": "Suggesting an edit to a note",

  // patients.*
  "patients.list": "Looking up your patients",
  "patients.search": "Searching for a patient",
  "patients.get": "Pulling up a patient",
  "patients.create": "Creating a patient record",
  "patients.attach_notes": "Attaching notes to a patient",
  "patients.detach_notes": "Detaching notes from a patient",

  // templates.*
  "templates.list": "Browsing your templates",
  "templates.get": "Reading a template",
  "templates.create": "Creating a template",
  "templates.propose_field_edit": "Suggesting a template edit",

  // memory.* (memory.get is hidden via HIDDEN_TOOL_NAMES)
  "memory.update": "Updating memory",

  // navigation.*
  "navigation.get_url": "Looking up a page",
  "navigation.propose": "Suggesting a page",
  "navigation.go": "Opening a page",

  // support.*
  "support.search": "Searching the help docs",

  // support_escalation.*
  "support_escalation.trigger": "Reaching out to support",

  // user_context.*
  "user_context.get": "Checking your account",

  // treats.*
  "treats.get": "Checking your treat balance",
};

export function formatToolLabel(
  tool: string,
  action?: string,
): string {
  if (action) {
    const keyed = TOOL_LABEL[`${tool}.${action}`];
    if (keyed) return keyed;
  }
  return TOOL_LABEL[tool] ?? tool.replace(/_/g, " ");
}
